export default "__VITE_ASSET__BVojRTuS__"